import React from 'react';

const Error403: React.FC = () => (
    <div id="content" className='content'>
        <div className="error">
            <header>
                <h1>Sorry, Forbidden</h1>
            </header>
            <article>
                <p>403 Error</p>
                <p>Sorry, you are not authorized to view the page you requested</p>
            </article>
            <footer>
                <a href="/">Home</a>
            </footer>
        </div>
    </div>
);

const Error404: React.FC = () => (
    <div id="content" className='content'>
        <div className="error">
            <header>
                <h1>Sorry, Nothing Found</h1>
            </header>
            <article>
                <p>404 Error</p>
                <p>The page you requested could not be found on our server</p>
            </article>
            <footer>
                <a href="/">Home</a>
            </footer>
        </div>
    </div>
);

export { Error403, Error404 };